import { z } from 'zod';

export const pendingReceiptInputSchema = z.object({
  jobId: z.string().uuid(),
  // The queued receipt, as a reference into the job's file store.
  fileId: z.string().uuid().nullable().optional(),
});

/**
 * The queued receipt's file record. `contentType` is nullable — backfilled rows
 * derived it from an R2 HEAD that could answer without one — so `fileName` is
 * the fallback when picking a viewer.
 */
export const pendingReceiptFileSchema = z.object({
  id: z.string().uuid(),
  contentType: z.string().nullable(),
  fileName: z.string(),
});

export const pendingReceiptSchema = z.object({
  id: z.string().uuid(),
  jobId: z.string().uuid(),
  fileId: z.string().uuid().nullable(),
  uploadedBy: z.string().uuid(),
  createdAt: z.string(),
  // Only the list endpoint joins it; the create response is the bare row, and
  // its one caller reads nothing but the id.
  file: pendingReceiptFileSchema.nullable().optional(),
});

export type PendingReceiptInput = z.infer<typeof pendingReceiptInputSchema>;
export type PendingReceipt = z.infer<typeof pendingReceiptSchema>;
